<template>
  <div>
    <b-col
      cols="12"
      class="h5 text-azul-medio font-weight-normal px-0 text-center text-lg-left gilmer"
    >
      INFORMACIÓN INSTITUCIONAL
    </b-col>
    <div class="rounded border border-violeta-claro p-3">
      <b-row>
        <b-col cols="12" lg="7">
          <b-row>
            <Simbologia
              :rbd="Number(establecimiento.rbd)"
              class="col col-print-7 row justify-content-center"
              posicionTooltip="top"
              :mostrarCopago="false"
              :genero="establecimiento.informacionInstitucional.regimen"
              :subvencionPreferencial="esSep(establecimiento)"
              :integracionEscolar="esPie(establecimiento)"
            />
          </b-row>
          <CartaDatos
            :rbd="Number(establecimiento.rbd)"
            :director="establecimiento.director.nombre"
            :dependencia="textoDependencia(establecimiento)"
            :nivelMenor="establecimiento.nivelMinimo"
            :nivelMayor="establecimiento.nivelMaximo"
            :ensenianza="'Científico - Humanista'"
            :orientacion="
              establecimiento.informacionInstitucional.orientacionReligiosa
            "
            :uniforme="
              establecimiento.informacionInstitucional.politicaUniforme
            "
          />
        </b-col>
        <b-col cols="12" lg="5">
          <GaleriaImagenes
            :rbd="establecimiento.rbd"
            :imagenes="imagenes"
            :imagenPrincipal="imagenPrincipal"
          />
        </b-col>
        <EspecialidadesYAdicionales
          :especialidades="
            establecimiento.especialidades ? establecimiento.especialidades : []
          "
          :adicionales="adicionales"
        />
      </b-row>
      <ProyectoEducativo
        :rbd="establecimiento.rbd"
        :textoProyecto="
          establecimiento.informacionInstitucional.resumenProyecto
        "
        :archivoProyecto="
          establecimiento.informacionInstitucional.documentoProyecto
        "
        :reglamentoInterno="
          establecimiento.informacionInstitucional.documentoReglamento
        "
        :tienePIE="esPie(establecimiento)"
      />
      <ProyectoIntegracion
        v-if="esPie(establecimiento)"
        :rbd="establecimiento.rbd"
        :textoProyecto="
          establecimiento.informacionInstitucional.resumenProyecto
        "
        :resumenProyectoPIE="
          establecimiento.informacionInstitucional.resumenProyectoPIE
        "
      />
      <ProcedimientosEspeciales
        v-if="mostrarProcedimientosEspeciales"
        :rbd="establecimiento.rbd"
        :procesos="
          establecimiento.procesosEspeciales
            ? establecimiento.procesosEspeciales
            : []
        "
      />
      <PagosDatosEstadisticas
        :alumnosMatriculados="
          establecimiento.informacionInstitucional.alumnosMatriculados
        "
        :promedioAlumnos="
          establecimiento.informacionInstitucional.promedioAlumnosPorCurso
        "
        :docentes="establecimiento.informacionInstitucional.cantidadDocentes"
        :sedes="establecimiento.sedes"
      />
      <Internado
        v-if="mostrarDisclaimerInternado"
        :infoInstitucionalInternado="
          establecimiento.informacionInstitucional.internado
        "
      />
      <IndicadoresCalidad
        :indicadores="
          establecimiento.indicadores ? establecimiento.indicadores : []
        "
      />
      <ProgramasYExtras :actividades="establecimiento.actividades" />
    </div>
  </div>
</template>

<script>
import Simbologia from "@/components/generales/Simbologia";
import CartaDatos from "@/components/ficha/izquierda/CartaDatos";
import GaleriaImagenes from "@/components/ficha/izquierda/GaleriaImagenes";
import ProyectoEducativo from "@/components/ficha/izquierda/ProyectoEducativo";
import ProyectoIntegracion from "@/components/ficha/izquierda/ProyectoIntegracion";
import ProcedimientosEspeciales from "@/components/ficha/izquierda/ProcedimientosEspeciales";
import Internado from "@/components/ficha/izquierda/Internado";
import PagosDatosEstadisticas from "@/components/ficha/izquierda/PagosDatosEstadisticas";
import EspecialidadesYAdicionales from "@/components/ficha/izquierda/EspecialidadesYAdicionales";
import IndicadoresCalidad from "@/components/ficha/izquierda/IndicadoresCalidad";
import ProgramasYExtras from "@/components/ficha/izquierda/ProgramasYExtras";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faMapMarkerAlt);

export default {
  components: {
    FontAwesomeIcon,
    Simbologia,
    CartaDatos,
    GaleriaImagenes,
    ProyectoEducativo,
    ProyectoIntegracion,
    ProcedimientosEspeciales,
    PagosDatosEstadisticas,
    EspecialidadesYAdicionales,
    IndicadoresCalidad,
    ProgramasYExtras,
    Internado
  },
  props: {
    establecimiento: {
      type: Object,
      required: true
    }
  },
  methods: {
    //calcula texto dependencia
    textoDependencia: function(establecimiento) {
      switch (establecimiento.dependencia) {
        case "PARTICULAR SUBVENCIONADO":
          return "Particular subvencionado";
        default:
          return "Público";
      }
    },
    esSep(establecimiento) {
      if (establecimiento.etiquetas !== undefined) {
        return establecimiento.etiquetas.includes("SEP");
      } else {
        return false;
      }
    },
    esPie(establecimiento) {
      if (establecimiento.etiquetas !== undefined) {
        return establecimiento.etiquetas.includes("PIE");
      } else {
        return false;
      }
    }
  },
  computed: {
    //calcula caracteristicas adicionales del establecimiento
    adicionales() {
      let arreglo = [];
      this.establecimiento.informacionInstitucional.internado
        ? arreglo.push("Internado")
        : null;
      this.establecimiento.informacionInstitucional.peib
        ? arreglo.push("Programa de Educación Intercultural Bilingüe")
        : null;
      return arreglo;
    },
    //obtiene imagenes del establecimiento
    imagenes() {
      return this.establecimiento.imagenes
        ? this.establecimiento.imagenes.map(data => {
            return data.nombre;
          })
        : [];
    },
    //obtiene imagen principal del establecimiento
    imagenPrincipal() {
      let img = "";

      if (this.establecimiento.imagenes) {
        let dataImagen = this.establecimiento.imagenes.find(data => {
          return data.principal;
        });
        let ext = dataImagen
          ? dataImagen.nombre.slice(
              ((dataImagen.nombre.lastIndexOf(".") - 1) >>> 0) + 2
            )
          : "jpg";
        dataImagen
          ? (img = `miniatura.${ext}`)
          : this.establecimiento.imagenes.length > 0
          ? (img = this.establecimiento.imagenes[0].nombre)
          : (img = "");
      }
      return img;
    },
    mostrarProcedimientosEspeciales() {
      return localStorage.getItem("mostrarProcedimientosEspeciales") === "1";
    },
    mostrarDisclaimerInternado() {
      return this.establecimiento.etiquetas.includes("INTERNADO");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/InformacionInstitucional.vue